angular.module('env.data.models.stepModel', [])

    .config(function (restProvider, RepresentationModelFieldTypes) {
        restProvider.defineModel("StepModel",
            {
                extend: ['BaseModel'],
                fields: {
                    code: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    publicNameResource: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    nameResource: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    type: {
                        type: RepresentationModelFieldTypes.INTEGER
                    }
                }
            }
        );
    })

;